var React = require('react');

function YellowShape (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .e797abf0-24f6-4bac-8d95-8ed4a4854d6d {\n        fill: #fecd05;\n      }\n    ")),React.createElement("g",{"id":"bde7e324-da49-4d71-bd22-bcfb387b7ff7","data-name":"Group 303","key":1},React.createElement("polygon",{"className":"e797abf0-24f6-4bac-8d95-8ed4a4854d6d","points":"288 0 288 23.46 251.34 59 0 59 0 0 288 0"}))]);
}

YellowShape.defaultProps = {"id":"b330c7a4-de4d-4b81-8594-7aed62c5c493","data-name":"Layer 1","viewBox":"0 0 288 59"};

module.exports = YellowShape;

YellowShape.default = YellowShape;
